"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appWithCanonicalUrls = exports.appWithLanguageUrls = void 0;
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const isEmpty_1 = __importDefault(require("lodash/fp/isEmpty"));
const next_i18next_1 = require("next-i18next");
const head_1 = __importDefault(require("next/head"));
const react_1 = __importDefault(require("react"));
const libs_context_page_type_1 = require("@hotelplan/libs.context.page-type");
const libs_router_config_1 = require("@hotelplan/libs.router-config");
const platform_graphql_api_1 = require("@hotelplan/platform-graphql-api");
const language_urls_context_1 = require("./language-urls.context");
const language_urls_prop_1 = require("./language-urls.prop");
const language_urls_utils_1 = require("./language-urls.utils");
function appWithLanguageUrls(options = {}) {
    const { addCanonical = true } = options;
    return function (WrappedAppComponent) {
        function AppWithLanguageUrls(props) {
            const [, { language }] = (0, next_i18next_1.useTranslation)();
            const routeProp = (0, libs_router_config_1.getRoutePageProp)(props.pageProps);
            const languageUrlsProp = (0, language_urls_prop_1.getPagePropsLanguageURLs)(props.pageProps);
            const pageType = (0, libs_context_page_type_1.getPageTypeProp)(props.pageProps);
            const routeLanguageUrls = routeProp
                ? (0, language_urls_utils_1.createRouteLanguageUrls)(routeProp)
                : {};
            const languageUrlsOnly = (0, language_urls_utils_1.mapLinksToLanguageUrls)(routeProp.origin, routeLanguageUrls, (0, isEmpty_1.default)(languageUrlsProp)
                ? {}
                : (0, language_urls_utils_1.fallbackLanguageURLsToHome)(languageUrlsProp));
            // lang -> url: string
            const languageUrls = Object.assign(Object.assign({}, routeLanguageUrls), languageUrlsOnly);
            let canonical;
            let alternativeUrls = {};
            if (addCanonical) {
                const canonicalUrlsOnly = (0, language_urls_utils_1.mapLinksToLanguageUrls)(routeProp.origin, routeLanguageUrls, (0, language_urls_prop_1.getCanonicalURLsPageProp)(props.pageProps));
                // language urls without fallback urls
                const pureLanguageUrls = (0, language_urls_utils_1.omitFallbackLinks)(languageUrlsProp);
                // canonical urls
                // fallback to language urls without fallbacks when its empty
                let canonicalUrls;
                if (!(0, isEmpty_1.default)(canonicalUrlsOnly)) {
                    canonicalUrls = canonicalUrlsOnly;
                }
                else if (!(0, isEmpty_1.default)(pureLanguageUrls)) {
                    canonicalUrls = (0, language_urls_utils_1.mapLinksToLanguageUrls)(routeProp.origin, routeLanguageUrls, pureLanguageUrls);
                }
                else {
                    canonicalUrls = routeLanguageUrls;
                }
                canonical = canonicalUrls[language];
                alternativeUrls = canonicalUrls;
            }
            const alternativeUrlLanguages = Object.keys(alternativeUrls);
            return (react_1.default.createElement(react_1.default.Fragment, null,
                addCanonical && pageType !== platform_graphql_api_1.PageType.Page_404 ? (react_1.default.createElement(head_1.default, null,
                    canonical && (react_1.default.createElement("link", { key: "canonical", rel: "canonical", href: canonical })),
                    alternativeUrlLanguages.length > 1
                        ? alternativeUrlLanguages.map(lang => (react_1.default.createElement("link", { key: `alternate-${lang}`, rel: "alternate", href: alternativeUrls[lang], hrefLang: lang })))
                        : null)) : null,
                react_1.default.createElement(language_urls_context_1.LanguageUrlsContext.Provider, { value: { urls: languageUrls, canonical } },
                    react_1.default.createElement(WrappedAppComponent, Object.assign({}, props)))));
        }
        return (0, hoist_non_react_statics_1.default)(AppWithLanguageUrls, WrappedAppComponent);
    };
}
exports.appWithLanguageUrls = appWithLanguageUrls;
/**
 * @deprecated Use `appWithLanguageUrls`. Renamed.
 */
exports.appWithCanonicalUrls = appWithLanguageUrls;
//# sourceMappingURL=appWithLanguageUrls.js.map